import { mdiContentCopy } from '@mdi/js';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import IconButton from '../../../components/ui/icon-btn';

interface Props {
  value: string;
}

const JsonCell: React.FC<Props> = ({ value }) => {
  if (!value) return <span>-</span>;

  let tooltipContent = value;
  try {
    tooltipContent = JSON.stringify(JSON.parse(value), null, 2);
  } catch (e) {
  }

  const renderTooltip = (props: any) => (
    <Tooltip
      id="json-tooltip"
      {...props}
      style={{ ...props.style, maxWidth: '600px', textAlign: 'left' }}
    >
      <pre style={{
        margin: 0,
        color: 'white',
        fontSize: '11px',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        maxWidth: '100%'
      }}>
        {tooltipContent}
      </pre>
    </Tooltip>
  );

  const handleCopy = () => {
    navigator.clipboard.writeText(tooltipContent);
  };

  return (
    <div className="d-flex align-items-center justify-content-between" style={{ width: '100%' }}>
      <OverlayTrigger
        placement="top"
        delay={{ show: 200, hide: 100 }}
        overlay={renderTooltip}
      >
        <span
          className="d-inline-block text-truncate"
          style={{ maxWidth: '180px', cursor: 'text', color: '#555', fontFamily: 'monospace', fontSize: '0.85em' }}
        >
          {value}
        </span>
      </OverlayTrigger>

      <IconButton
        mdiIconPath={mdiContentCopy}
        size="16px"
        onClick={handleCopy}
        title="Copy content"
        color="var(--primary)"
        styleType="default"
        className="ms-2"
      />
    </div>
  );
};

export default JsonCell;